import React from 'react';
import { Link } from 'react-router-dom';
import '../index.css';

const UserAvatar = ({ user }) => {
  const [imageError, setImageError] = React.useState(false);
  const avatarUrl = user.profile?.avatar?.url;

  if (avatarUrl && !imageError) {
    return (
      <img 
        src={avatarUrl} 
        alt={user.username}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        onError={() => setImageError(true)}
      />
    );
  }

  return (
    <div style={{
      width: '100%',
      height: '100%',
      backgroundColor: 'var(--card-bg)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1.5rem',
      color: 'var(--primary)'
    }}>
      {user.username.charAt(0).toUpperCase()}
    </div>
  );
};

const UserListModal = ({ title, users, loading, onClose }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    }} onClick={onClose}>
      <div style={{
        backgroundColor: 'var(--card-bg)',
        borderRadius: '20px',
        width: '100%',
        maxWidth: '500px',
        maxHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid var(--border-color)',
        boxShadow: '0 20px 50px rgba(0, 0, 0, 0.5)'
      }} onClick={(e) => e.stopPropagation()}>
        
        {/* Header */}
        <div style={{
          padding: '20px',
          borderBottom: '1px solid var(--border-color)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h2 style={{ margin: 0, fontSize: '1.5rem', color: 'var(--text-primary)' }}>{title}</h2>
          <button 
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--text-secondary)',
              fontSize: '2rem',
              cursor: 'pointer',
              lineHeight: 1,
              padding: '0 5px'
            }}
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div style={{
          overflowY: 'auto',
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px'
        }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <div style={{ fontSize: '1.2rem', color: 'var(--text-secondary)' }}>Loading...</div>
            </div>
          ) : users && users.length > 0 ? (
            users.map((user) => (
              <Link 
                key={user._id} 
                to={`/profile/${user.username}`}
                onClick={onClose}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '15px',
                  padding: '12px',
                  backgroundColor: 'var(--bg-dark)',
                  borderRadius: '12px',
                  textDecoration: 'none',
                  transition: 'transform 0.2s ease, background-color 0.2s ease',
                  border: '1px solid var(--border-color)'
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--bg-darker)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--bg-dark)';
                    e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                {/* Avatar */}
                <div style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  flexShrink: 0,
                  border: '2px solid var(--primary)'
                }}>
                  <UserAvatar user={user} />
                </div>

                {/* Info */}
                <div style={{ flex: 1 }}>
                  <div style={{ 
                    color: 'var(--text-primary)', 
                    fontWeight: 'bold', 
                    fontSize: '1.1rem',
                    marginBottom: '4px' 
                  }}>
                    {user.username}
                  </div>
                  {user.accountType && (
                    <span style={{
                      fontSize: '0.75rem',
                      padding: '2px 8px',
                      borderRadius: '10px',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      color: 'var(--text-secondary)'
                    }}>
                      {user.accountType.replace('_', ' ').toUpperCase()}
                    </span>
                  )}
                </div>
              </Link>
            ))
          ) : (
            <div style={{ textAlign: 'center', padding: '30px', color: 'var(--text-secondary)' }}>
              No users found.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserListModal;
